<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙S2B2C</div>
            <div class="banner_line"></div>
            <div class="banner_title2">帮助品牌/平台企业打造全链路管理平台，整合上游资源，管理中端渠道，赋能下游零售客户，为顾客提供更好的产品和服务</div>
            <!-- <div class="banner_text">帮助品牌/平台企业打造全链路管理平台，整合上游资源，管理中端渠道，赋能下游零售客户，为顾客提供更好的产品和服务</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcCommerce/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">行业挑战</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCommerce/programme1.png" alt="">
            <img src="@/assets/Mobile/images/QcCommerce/programme2.png" alt="">
            <img src="@/assets/Mobile/images/QcCommerce/programme3.png" alt="">
            <img src="@/assets/Mobile/images/QcCommerce/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">通过平台整合上下游资源，打通全链路交易</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcCommerce/programme5.png" alt="">
        </div>
      </div>

      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">通过平台整合优质供应链资源，实现高效运营管理，为客户提升更优质的产品和服务</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCommerce/programme6.png" alt="">
        </div>
      </div>

      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">打通厂商/品牌商和下游各级经销渠道，实现各经销渠道明确可控</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCommerce/programme7.png" alt="" style="margin-left: 30px;">
        </div>
      </div>

      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">线上线下互通互融，为消费者提供全渠道便捷购物服务</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcCommerce/programme8.png" alt="">
        </div>
      </div>

      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">千橙产品矩阵，为企业客户高效管理全链路交易</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcCommerce/programme9.png" alt="">
        </div>
      </div>
      
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCommerce/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcCommerce/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙S2B2C" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙S2B2C" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcCommerce,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .programme1{
    background: #F8FCFF;
  }
  .programme2{
    background: #FFFFFF;
  }
  .programme3{
    background: #202239;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  